import React, { useState, useEffect, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import authApi from '../../../service/IdApi'; // Ensure this import is available
import { useAppContext } from '../../../context/appContext';

const CreditHistoryDialog = ({ visible, onHide, providerId }) => {
    const { displayAlert } = useAppContext();
    const [creditHistory, setCreditHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);

    const fetchCreditHistory = useCallback(async (providerId) => {
        setIsLoading(true);
        try {
            const result = await authApi.get(`/admin/provider/${providerId}/credit-history`);
            if (Array.isArray(result.data.data)) {
                setCreditHistory(result.data.data);
                setTotalAmount(calculateTotalAmount(result.data.data));
            } else {
                console.error("Expected an array but got:", result.data.data);
                setCreditHistory([]); // Set to an empty array if not as expected
            }
        } catch (error) {
            displayAlert("error", "Unexpected Error", "Failed to fetch credit history");
        } finally {
            setIsLoading(false);
        }
    }, [displayAlert]);

    useEffect(() => {
        if (visible && providerId) {
            fetchCreditHistory(providerId);
        }
    }, [visible, providerId, fetchCreditHistory]);

    const calculateTotalAmount = (data) => {
        return data ? data.reduce((acc, item) => acc + item.amount, 0) : 0;
    };

    const creditAmountBodyTemplate = (rowData) => {
        return <>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(rowData.amount)}</>;
    };

    return (
        <Dialog
            visible={visible}
            style={{ width: "600px" }}
            header="Credit History"
            modal
            onHide={onHide}
        >
            {isLoading ? (
                <div className="flex justify-content-center">
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                </div>
            ) : (
                <DataTable value={creditHistory} emptyMessage="No credit history">
                    <Column field="date" header="Date" style={{ width: '120px' }} />
                    <Column field="description" header="Description" />
                    <Column field="amount" header="Amount" body={creditAmountBodyTemplate} className="text-right" headerClassName="right-aligned-header" footer={creditHistory.length !== 0 ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(totalAmount) : null}
                        footerStyle={{ fontWeight: 'bold' }}></Column>
                </DataTable>
            )}
        </Dialog>
    );
};

export default CreditHistoryDialog;